import { render, staticRenderFns } from "./CustomDataList.vue?vue&type=template&id=2e78d412&scoped=true"
import script from "./CustomDataList.vue?vue&type=script&lang=js"
export * from "./CustomDataList.vue?vue&type=script&lang=js"
import style0 from "./CustomDataList.vue?vue&type=style&index=0&id=2e78d412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78d412",
  null
  
)

export default component.exports